import styles from "../globals/pages.module.scss";
import ClaimFormMailReferral from "../components/claimFormMailReferral/main";

function MakeClaimMailReferral() {
    return (
        <div className={`${styles.pcpClaimFormContainer}`}>
            <ClaimFormMailReferral />
        </div>
    );
}

export default MakeClaimMailReferral;
